import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { dramas } from '@/mocks/dramas';
import type { Drama } from '@/types/content';

interface FlatEpisode {
  dramaId: string;
  dramaTitle: string;
  category: string;
  cover: string;
  no: number;
  title: string;
  summary: string;
  date: string;
}

const latestEpisodes: FlatEpisode[] = ([...dramas] as Drama[])
  .flatMap((drama) =>
    drama.episodes.map((ep) => ({
      dramaId: drama.id,
      dramaTitle: drama.title,
      category: drama.category,
      cover: drama.cover,
      no: ep.no,
      title: ep.title,
      summary: ep.summary,
      date: ep.date,
    })),
  )
  .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : b.no - a.no))
  .slice(0, 6);

export default function LatestEpisodes() {
  return (
    <section id="latest" className="w-full scroll-mt-24 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Episode Guide"
          title="最新分集剧情介绍"
          desc="按更新时间倒序排列的最新剧集，点开对应短剧可以查看完整的连续剧集更新顺序。"
          actionText="查看热门剧集"
          actionTo="/dramas"
        />

        <div className="mt-10 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
          {latestEpisodes.map((ep) => (
            <article key={`${ep.dramaId}-${ep.no}`} className="bg-background-50 transition-colors hover:bg-background-100">
              <Link to={`/drama/${ep.dramaId}`} className="flex cursor-pointer flex-col gap-4 p-4 sm:flex-row md:p-5">
                <div className="h-[120px] w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-[110px] sm:w-[82px]">
                  <img
                    src={ep.cover}
                    alt={`《${ep.dramaTitle}》第${ep.no}集封面`}
                    title={`${ep.dramaTitle} 第${ep.no}集 剧情介绍`}
                    className="h-full w-full object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="rounded-md bg-primary-50 px-2 py-0.5 text-xs text-primary-700">
                      第 {ep.no} 集
                    </span>
                    <h3 className="text-sm font-medium text-foreground-950">{ep.dramaTitle}</h3>
                    <span className="text-xs text-foreground-400">· {ep.category}</span>
                  </div>
                  <h4 className="mt-2 text-sm text-foreground-800">
                    <span className="cursor-pointer transition-colors hover:text-primary-600">
                      {ep.title}
                    </span>
                  </h4>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-6 text-foreground-600">{ep.summary}</p>
                  <p className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-calendar-line" aria-hidden="true" />
                    上线时间 {ep.date}
                  </p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}